import PageTitle from 'components/Typography/PageTitle';

import LargeSectionHeader from 'components/Typography/LargeSectionHeader';

import MediumSectionHeader from 'components/Typography/MediumSectionHeader';

import SmallSectionHeader from 'components/Typography/SmallSectionHeader';

import LongBody from 'components/Typography/LongBody';

import ShortBody from 'components/Typography/ShortBody';
import Captions from 'components/Typography/Captions';

export {
  PageTitle,
  LargeSectionHeader,
  MediumSectionHeader,
  SmallSectionHeader,
  LongBody,
  ShortBody,
  Captions,
};
